module.exports = __webpack_public_path__ + "img/Syed.1419b09b.jpg";